<template>
    <div class="input-pfs-curveplot">
        <div style="margin-bottom: 10px; padding: 10px; background: #ebebeb">
          Render PFS survival curve straified by clinical variables or dichotomized continuous variables. 
        </div>
<!-- Select type of variables to straitify the curve, clinical vs genomics -->
        <!-- Choose variable, if genomics, choose the specific type of omics -->
        <v-select
          v-model="pfsCurveVarType"
          :items="varTypes"
          outlined
          :menu-props="{closeOnContentClick: true}"
          dense
          :label="`Select the variable type`"
          clearable
          
          ></v-select>
    
          <v-autocomplete
            v-if="showVarNames()"
            v-model="pfsCurveVarName"
            :items="pfsVarList()"
            outlined
          :menu-props="{closeOnContentClick: true}"
          dense
          :label="`Input the straified variable`"
          clearable

            ></v-autocomplete>

            <v-select
            v-if="showVarOmics()"
            v-model="pfsCurveVarOmics"
            :items="pfsOmicsList()"
            outlined
          :menu-props="{closeOnContentClick: true}"
          dense
          :label="`Select the omic type of the selected gene`"
          clearable
            ></v-select>
      <v-btn
      v-if="valid()"
        elevation="2"
        color="blue lighten-2"
        dark
        @click="setPfsCurve"
      > 
        Submit variables
      </v-btn>
      <input-pfs-curveplot-customize :studySelected="this.studySelected" />
    </div>
  </template>
  
  <script>
  import InputPfsCurveplotCustomize from './InputPfsCurveplotCustomize.vue'
  
  export default {
      components: { 
        InputPfsCurveplotCustomize  
    },
      
      name: "input-pfs-curveplot",
      props: ['studySelected'],
      computed: {
        available() {
          console.log('computed available pfscurve', this.studySelected)
          if (this.studySelected === 'PCC') {
            return this.$store.state.availableGenes['PCC']
          } else {
            return this.$store.state.availableGenes['PTRC']
          }
        },
          // loaderBoxplot() { return this.$store.state.loaderBoxplot },
          varTypes() { 
            console.log('test varTypes', this.$store.state.PfsCurveplot_varTypes[this.studySelected])
            return Object.keys(this.$store.state.PfsCurveplot_varTypes[this.studySelected]) },
          
          genes() { 
              const available = Object.keys(this.available)
              available.sort()
              return available
          },
          
      },
      
      data: () => ({
          loading: false,
          pfsCurveVarType: '',
          pfsCurveVarName: '',
          pfsCurveVarOmics: '',
          dataTypes: ['CNV', 'Proteo', 'RNA', 'CellType']
      }),

  
  
      methods: {
            submitVarType() {
              console.log('test varType before', this.$store.state.PfsCurveplot_varType)
                this.$store.dispatch('setViewAttr', { 
                            view: 'PfsCurveplot',
                            attrKey: 'varType',
                            attrValue: this.pfsCurveVarType
                            })
                console.log('test varType after', this.$store.state.PfsCurveplot_varType)
                
              },
            submitVarName() {
                this.$store.dispatch('setViewAttr', { 
                            view: 'PfsCurveplot',
                            attrKey: 'varName',
                            attrValue: this.pfsCurveVarName
                            })
                console.log('test varName', this.$store.state.PfsCurveplot_varName)
            },
            submitVarOmics() {
                this.$store.dispatch('setViewAttr', { 
                            view: 'PfsCurveplot',
                            attrKey: 'varOmics',
                            attrValue: this.pfsCurveVarOmics
                            })
                console.log('test varOmics', this.$store.state.PfsCurveplot_varOmics)
            },
        //   submitScatterplotGenes() {
        //       this.$store.dispatch('getTracks', 
        //       { 
        //         view: 'Scatterplot', 
        //         genes: [this.scatterplotGeneA, this.scatterplotGeneB ],
        //       }
        //     )
        //   },
          showVarNames() {
            return this.pfsCurveVarType !== '' ? true : false
          },
          showVarOmics() {
            return (this.pfsCurveVarType === 'Genes' && this.pfsCurveVarName !== '') ? true : false
          },

          pfsVarList() {
            console.log('test pfsVarList', this.$store.state.PfsCurveplot_varName)
            console.log('test pfsVarList pfsCurveVarType', this.pfsCurveVarType)

            if (this.pfsCurveVarType == '') {
              return []
            } else if (this.pfsCurveVarType === 'Genes') {
                return Object.keys(this.$store.state.PfsCurveplot_varTypes[this.studySelected][this.pfsCurveVarType])
            } else {
                return this.$store.state.PfsCurveplot_varTypes[this.studySelected][this.pfsCurveVarType]
            }
          },
          pfsOmicsList() {
            if (this.pfsCurveVarType === 'Genes') {
                // TODO: parse the omics type from the gene name
                console.log('pfsOmicsList studySelected', this.studySelected)
                var gene_dict = this.$store.state.geneTracksList[this.studySelected][this.pfsCurveVarName]
                console.log('pfsOmicsList substrings', gene_dict)
                var pattern = new RegExp(`${this.pfsCurveVarName} |${this.pfsCurveVarName}_`, 'g');

                var substrings = gene_dict.map(str => str.replace(pattern, ''));
                console.log('pfsOmicsList substrings', substrings)
                return substrings
                // return ['Proteo', 'RNA', 'CNV', 'Cell type']
            } else {
                return []
            }
          },
          valid() { 
            if (this.pfsCurveVarType === 'Genes') {
                if (this.pfsCurveVarName !== '' && this.pfsCurveVarOmics !== '') {
                    return true
                }
                return false
            } else {
                if (this.pfsCurveVarName !== '') {
                    return true
                }
                return false
            }
        },
          setPfsCurve() {

            this.$store.dispatch('setViewAttr', { 
                            view: 'PfsCurveplot',
                            attrKey: 'varType',
                            attrVal: this.pfsCurveVarType
                            })
            this.$store.dispatch('setViewAttr', {
                            view: 'PfsCurveplot',
                            attrKey: 'varName',
                            attrVal: this.pfsCurveVarName
                            })
            this.$store.dispatch('setViewAttr', {
                            view: 'PfsCurveplot',
                            attrKey: 'varOmics',
                            attrVal: this.pfsCurveVarOmics
                            })
            console.log('setPfsCurve varType after', this.$store.state.PfsCurveplot_varType)
            console.log('setPfsCurve varName after', this.$store.state.PfsCurveplot_varName)
            console.log('setPfsCurve varOmics after', this.$store.state.PfsCurveplot_varOmics)
            console.log('setPfsCurve before', this.pfsCurveVarType)
            var genes = ['A1BG', 'A2ML1', 'ACD', 'DUS2']
            if (this.pfsCurveVarType === 'Genes') {
                genes = [this.pfsCurveVarName]
            }
            
            this.$store.dispatch('getTracks', 
                { 
                    view: 'PfsCurveplot', 
                    genes: genes,
                    combine_bool: true,
                    studySelected: this.studySelected,
                }
            )
            console.log('setPfsCurve data after', this.$store.state.PfsCurveplot_data)
            console.log('setPfsCurve varName after', this.$store.state.PfsCurveplot_varName)
          },
      },
    watch: {
      available() {
        // genes() { 
        console.log('watch available boxplot', this.available, this.studySelected)
            const available = Object.keys(this.available)
            available.sort()
            this.genes = available
        // },
      },
      studySelected() {
        this.setPfsCurve()
      },
      pfsCurveVarType() {  
        console.log('test watch pfsCurveVarType', this.pfsCurveVarType)
        this.submitVarType()
        this.pfsVarList()
        this.pfsCurveVarName = ''
       },
      pfsCurveVarName() {  
        this.submitVarName()
        this.pfsVarOmics()
       },
      pfsCurveVarOmics() {  this.submitVarOmics() },
    },
  
  }
  </script>
  
  <style>
  .input-pfs-curveplot {
      margin: 10px;
  }
  
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .ttest-descriptor {
    width: 100%;
    margin: 10px;
    font-size: 0.8em;
  }
  </style>